<template>
    <div id="random_cards">
      <div class="mainSection">
      <div v-if="mainInfo.main.sectionId === 'social_responsibility' || mainInfo.main.sectionId === 'press_releases' || mainInfo.main.sectionId === 'press_releases_slider'"></div>
      <div class="main-title">{{mainInfo.main.title}}</div>
      <div :class="[lang === 'ar' ? 'flex-row-reverse' : '' , 'slider-description d-flex mx-auto']">
        <div :class="this.$lang === 'ar' ? 'right-dir' : ''">
          <router-link :to="routing === 'offers' ? '/offers' : ''">
            <a>
              <Span :style="routing && {cursor: 'pointer'}" :class="routing ? 'underline-1' : ''" class="description">{{mainInfo.main.description}}
                <img v-if="routing" :class="[lang === 'ar' ? 'mr-2' : '' ,'arrows']" src="../../assets/icons/arrows.svg">
              </Span>
            </a>
          </router-link>
        </div>
<!--        <div>-->
<!--          <img :class="[lang === 'ar' ? 'mr-2' : '' ,'arrows']" src="../../assets/icons/arrows.svg">-->
<!--        </div>-->
      </div>
      <div class="row-padding random-container d-flex justify-content-center align-items-center">
<!--        <div v-if="!display" class="h-100 d-flex align-items-center justify-center">-->
<!--          <div v-for="(item, index) in 5" :key="index" class="spinner-grow text-warning" role="status"></div>-->
<!--        </div>-->
<!--        <div v-if="error" class="h-100 d-flex align-items-center justify-center">-->
<!--          <img class="error-img" src="../../assets/images/crying.png" />-->
<!--        </div>-->
        <div>
          <random-card :error="error" :show="show" :data="mainInfo.slider[0]" v-if="mainInfo.main.cardType === 'offer'"/>
          <random-social :cardType="cardType"  :error="error" :show="show" :data="mainInfo.slider[0]" v-if="mainInfo.main.cardType !== 'offer'"/>
        </div>
        <div>
          <div v-if="mainInfo.main.cardType === 'offer'">
            <random-card :error="error" :show="show" :data="mainInfo.slider[1]"/>
            <random-card :error="error" :show="show" :data="mainInfo.slider[2]"/>
          </div>
          <div v-if="mainInfo.main.cardType !== 'offer'">
            <random-social :cardType="cardType" :error="error" :show="show" :data="mainInfo.slider[1]"/>
            <random-social :cardType="cardType" :error="error" :show="show" :data="mainInfo.slider[2]"/>
          </div>
        </div>
      </div>
      </div>
    </div>
</template>

<script>
import $ from 'jquery'
import RandomCard from '../cards/RandomCard'
import RandomSocial from '../cards/RandomSocial'
export default {
  name: 'RandomSection',
  components: { RandomSocial, RandomCard },
  props: {
    data: {
      type: Object
    },
    cardType: String,
    show: Boolean,
    error: Boolean,
    routing: String
  },
  data () {
    return {
      mainInfo: {
        main: { sectionId: 'social-responsibility', cardType: 'social-responsibility', title: '', description: '', image: '' },
        slider: []
      },
      lang: this.$lang
    }
  },
  created () {
    this.mainInfo = this.data
  },
  mounted () {
    setTimeout(() => {
      this.$lang === 'ar' ? $('#random_cards .description').css('font-family', 'Mtn-arabic-regular') : $('#random_cards .description').css('font-family', 'Mtn-regular')
      this.$lang === 'ar' ? $('img.arrows').css('transform', 'rotateY(180deg)') : $('img.arrows').css('transform', 'rotateY(0deg)')
    })
  }
}
</script>

<style  lang="scss" scoped>
@import "src/assets/sass/main";
#random_cards {
  //background: $--light-white;
  position: relative;
  z-index: 100;
}
.slider-description{
  /*width: max-content;*/
  width: 100vw;
  justify-content: center;
  align-items: center;
  padding: 0 5vw;
}
.circle-background{
  background-image: url("../../assets/images/MtnAppBack.png");
  background-position: right;
  position: absolute;
  width: 100% !important;
  height: 100%;
  right: 0;
  transform: rotate(180deg);
}
  .sliderSection{
    display: none;
  }
@media screen and (max-width: 700px) {
  .sliderSection{
    display: block;
  }
  .mainSection{
    display: none;
  }
}
</style>
